import {Button, ContextMenu} from '@esgi/ui';
import {Alert, alertColorsConfig} from '@esgi/ui/alert';
import {Text} from '@esgi/ui/typography';
import {AlertBody} from './components/body';
import {ContextMenuItem} from './index.styled';
import {menuItems} from './constants';
import {FileType} from '../../types';
import {Dispatch} from 'react';
import {GridBox} from '@esgi/ui/layout';
import {Settings} from './components/settings';

type Props = {
	onClose: VoidFunction;
	onDownload: Dispatch<FileType>;
};

export function PreviewDialog(props: Props) {
	const alertRef = Alert.useRef();
	const onClose = Alert.useClose(alertRef, props.onClose);

	return (
		<Alert
			modalManagerRef={alertRef}
			colorConfig={alertColorsConfig.neutral}
			defaultOpen={false}
		>
			<Alert.Header
				withBacklight={false}
				onCloseIconClick={onClose}
			>
				<Text size='large'>Student Detail Report</Text>
			</Alert.Header>
			<Settings/>
			<AlertBody/>
			<Alert.Footer>
				<ContextMenu.Root>
					<ContextMenu.Trigger>
						<Button color='primary'>
							<Text size='medium' bold>
								Download
							</Text>
						</Button>
					</ContextMenu.Trigger>
					<ContextMenu.Content>
						<ContextMenu.Group>
							{menuItems.map(({text, value, desc}) => (
								<ContextMenuItem
									key={value}
									onClick={() => props.onDownload(value)}
								>
									<GridBox>
										<Text size='medium' bold>{text}</Text>
										<Text size='small' color='neutral56'>{desc}</Text>
									</GridBox>
								</ContextMenuItem>
							))}
						</ContextMenu.Group>
					</ContextMenu.Content>
				</ContextMenu.Root>
			</Alert.Footer>
		</Alert>
	);
}
